import { memo } from 'react';
import { Button } from '@quickmd-llc/design-system';
import { formatTimeToAmPm } from '@utils';

interface Props {
  onClick: (time: string) => void;
  time: string;
}

function TimeSlot({ onClick, time }: Props): JSX.Element {
  const formattedTime = formatTimeToAmPm(time);

  function handleOnClick() {
    onClick(time);
  }

  return (
    <Button onClick={handleOnClick} priority="secondary" size="s">
      {formattedTime}
    </Button>
  );
}

export default memo(TimeSlot);
